import React from "react";
import { withNavBars } from "../../HOCs";
import ProfileView from "./profileView";

class ProfileViewParent extends React.Component {
  render() {
    return <ProfileView {...this.props} />;
  }
}
const props = { boxShadow: false }

export default withNavBars(ProfileViewParent, props);
